import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useUpdateOperationModal } from '../context/UpdateOperationModalContext';

const UpdateOperationModalHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useUpdateOperationModal();

  return (
    <Modal.Header>
      <h5 className="modal-title">
        {t('UpdateData')}&nbsp;
        <span className="text-muted ff-alt fs-14px text-right">
          ({t(data.operationType)})
        </span>
      </h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default UpdateOperationModalHeader;
